import {
  createSystem,
  defaultConfig,
  defineConfig,
} from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          red: { value: "#b70031" },
          green: { value: "#113e00" },
          lightGreen: { value: "#2f6f17" },
          yellow: { value: "#fffb00" },
          lightYellow: { value: "#fffce4" },
          lightDarkYellow: { value: "#fff5a5" },
        },
      },
      fonts: {
        body: { value: "Segoe UI, system-ui, -apple-system, Arial, sans-serif" },
        heading: { value: "Segoe UI, system-ui, -apple-system, Arial, sans-serif" },
      },
    },
  },
  globalCss: {
    "html, body": {
      scrollBehavior: "smooth",
    },
    body: {
      minHeight: "100vh",
    },
    "#root": {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    },
  },
});

export const system = createSystem(defaultConfig, config);
